export const checkIsAnotherOperator = (
  isAuth: boolean,
  phone: string,
  operatorMTS: boolean,
  errorOperatorInfo: boolean | null
) => isAuth && !!phone && !operatorMTS && !errorOperatorInfo
